import React from 'react';
import { ActionButton } from '@fluentui/react';
import DataTable from 'react-data-table-component';
import { KnowledgeBase, MarketplaceOffer } from '@the-real-insight/tri-model';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { usePlanDialog } from './hooks/usePlanDialog';

interface PlanPanelProps {
    type: any
    marketplaceOffer: MarketplaceOffer;
    setMarketplaceOffer: (marketplaceOffer: MarketplaceOffer) => void;
}

export default function PlanPanel({
    type,
    marketplaceOffer,
    setMarketplaceOffer,
}: PlanPanelProps) {
    const { t } = useTranslation();
    const {
        openPlanDialog,
        PlanDialog
    } = usePlanDialog({ type, marketplaceOffer, setMarketplaceOffer });

    const planColumns = [{
        name: '',
        width: '80px',
        cell: (plan: any) => <div>
            <ActionButton iconProps={{ iconName: 'Delete' }} onClick={() => {
                setMarketplaceOffer(new type({
                    ...marketplaceOffer,
                    plans: marketplaceOffer.plans.filter((p: any) => p.id !== plan.id)
                }));
            }} />
        </div>
    }, {
        name: 'Name',
        width: '150px',
        cell: (plan: any) => <div>{plan.name}</div>
    }, {
        name: 'Beschreibung',
        width: '300px',
        cell: (plan: any) => <div className="textS">{plan.description}</div>
    }, {
        name: 'Basisgebühr',
        width: '150px',
        cell: (plan: any) => <div>{plan.billings?.[0]?.offset} €</div>
    }, {
        name: 'Zusätzl. Nutzergebühr/Nutzer/Monat',
        width: '200px',
        cell: (plan: any) => <div>{plan.billings?.[0]?.fee} €</div>
    }, {
        name: 'Zeitraum (Monate)',
        width: '180px',
        cell: (plan: any) => <div>{plan.term}</div>
    }, {
        name: 'Gültig ab',
        width: '100px',
        cell: (plan: any) => <div>{plan.validFromDate ? dayjs(plan.validFromDate).format('DD.MM.YY') : '-'}</div>
    }, {
        name: 'Gültig bis',
        width: '100px',
        cell: (plan: any) => <div>{plan.validToDate ? dayjs(plan.validToDate).format('DD.MM.YY') : '-'}</div>
    }];
    return (
        <>
            <div className="marginTopM textHeading">Abrechnung</div>
            <ActionButton
                className='marginTopM'
                iconProps={{ iconName: 'Add' }}
                onClick={() => openPlanDialog()}
            >
                Plan hinzufügen
            </ActionButton>
            <div className='width1000 marginTopM borderNeutral'>
                <DataTable
                    data={marketplaceOffer.plans}
                    columns={planColumns}
                    selectableRows
                    selectableRowsSingle
                    onSelectedRowsChange={({ selectedRows }) => {
                        if (selectedRows && selectedRows.length > 0) {
                            openPlanDialog(selectedRows[0]);
                        }
                    }}
                    pagination
                />
            </div>
            <PlanDialog />
        </>
    );
} 